/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';

class Icon extends React.Component<Props> {

	static defaultProps: Props = {
		iconClass: '',
		title: '',
		onClick: () => {
			// do nothing
		}
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		const iconClass = props.iconClass !== '' ? (' glyphicons glyphicons-' + props.iconClass) : '';
		return (
			<span
				className={iconClass + (props.className ? ' ' + props.className : '')}
				title={props.title}
				onClick={props.onClick}
			/>
		);
	}
}

export default Icon;
